import { Alert } from "@emdur/ui";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { finishCallback } from "../lib/auth";
import { errorText } from "../lib/errors";

export function Callback() {
  const navigate = useNavigate();
  const [error, setError] = useState<unknown>(null);
  useEffect(() => {
    finishCallback(location.search).then((to) => navigate(to, { replace: true })).catch(setError);
  }, [navigate]);
  return error ? <Alert tone="danger">{errorText(error)}</Alert> : <p>Signing you in…</p>;
}
